<template>
  <div>
    <transition name="expand">
      <div v-if="hasQuestions">
        <transition name="expand">
          <router-view :key="$route.params.questionId"></router-view>
        </transition>
      </div>

      <div v-else-if="displayCustomContent">
        <div v-html="customContent"></div>
        <div class="App-buttons">
          <button-component color="primary" value="Next Step" />
        </div>
      </div>

      <!-- No questions, it's a custom type proxy with General powers -->
      <div v-else-if="!hasQuestions && isCustomType">
        <h1 class="headline">General Proxy</h1>
        <p>
          You are submitting a proxy with general powers.
        </p>
        <p>
          Your proxy may vote on your behalf with respect to all matters that
          may come before the meeting, as you could do if personally present at
          the meeting.
        </p>
        <p>Please click on the "Next" button below to continue.</p>

        <div class="App-buttons">
          <button-component color="primary" value="Next Step" />
        </div>
      </div>

      <!-- A bill-106 / ON Condo type proxy where there are no matters -->
      <div v-else>
        <h1 class="headline">Quorum Only</h1>
        <p>
          This meeting does not contain any substantive matters that require
          your vote (eg. election of directors, by-law votes). As such, your
          proxy will only be used for the purposes of achieving quorum.
        </p>
        <p>Please click on the "Next" button below to continue.</p>

        <div class="App-buttons">
          <button-component color="primary" value="Next Step" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash';
import ButtonComponent from '../Button.vue';
import {mapGetters} from 'vuex';
export default {
  components: {
    ButtonComponent
  },
  computed: {
    ...mapGetters('questions', ['questions']),
    ...mapGetters(['meetingOptions']),
    ...mapGetters('resident', ['isResident']),
    hasQuestions() {
      if (this.isResident === 'no' && this.questions.length === 1) {
        return false;
      }
      return this.questions.length > 0;
    },
    isCustomType() {
      const type = _.get(this.meetingOptions, 'proxy_template', '');
      return type === 'custom' || type === 'alberta';
    },
    displayCustomContent() {
      return _.get(
        this.meetingOptions,
        'display_custom_general_proxy_content',
        false
      );
    },
    customContent() {
      return _.get(this.meetingOptions, 'custom_general_proxy_content', '');
    }
  },
  methods: {
    backButtonClick() {
      this.$router.push({name: 'contact'});
    }
  }
};
</script>
